export enum ResetStatus {
    OFF = 0,
    FORGOT = 1,
    RESET = 2,
    FINISH = 3
}